module.exports = __webpack_public_path__ + "static/img/service_introduce_5116_zh_h5.74fe16b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5116_zh_h5.png
// module id = lcma
// module chunks = 34